// Template helpers for the admin console views. Unlike the main app's global s() (which mirrors physical
// styles for Persian because that reference has no RTL), the Admin Panel reference renders Persian with its
// own `dir="rtl"` root and unmirrored inline styles — so styles pass through verbatim here.
import { pseudoClass } from '@/styles/pseudo';

export const s = (css: string): string => css;
/** Reference `style-hover` → generated :hover class with !important declarations (dc-runtime behaviour). */
export const hv = (css: string): string => pseudoClass('hover', css, false);
